package com.evoapps.evoshift.domain.repository

/**
 * SH-269: the position and skills of several people at one workplace in one batch
 * (users/{uid}.engagements.{wpId}.role / .skills, as the employee form writes them; firestore.rules
 * let a workplace's managers change those of its people, one engagement per profile write).
 */
interface TeamBulkRepository {
    suspend fun updateRolesAndSkills(workplaceId: String, updates: List<RoleSkillsUpdate>): Result<Unit>
}

/** One person's position and / or skills at the workplace (null: as it is). */
data class RoleSkillsUpdate(val userId: String, val role: String? = null, val skills: List<String>? = null)
